/**
 * A question with a short list of answers, and no way out but one of them.
 *
 * The chapter panel's sibling, for the two moments the story asks you
 * something rather than tells you something: who has been feeding him, and
 * what you do about it. Same card, same stripe, and the same rule as the
 * chapter: no close button and no Escape. A number key picks the row with
 * that number on it.
 */
export function createChoicePanel({ parent }) {
  const root = document.createElement('div');
  root.className = 'chapter choice';
  root.hidden = true;
  parent.append(root);

  let asked = null;

  function pick(id) {
    if (!asked) return false;
    const option = asked.options.find((candidate) => candidate.id === id);
    if (!option) return false;
    const then = asked.onPick;
    root.hidden = true;
    asked = null;
    then?.(option.id);
    return true;
  }

  function render() {
    root.innerHTML = `
      <div class="chapter-card" data-kind="choice">
        <span class="chapter-kicker">${asked.kicker ?? 'Your call'}</span>
        <h2>${asked.title}</h2>
        <span class="chapter-speaker">${asked.speaker}</span>
        <p class="chapter-line">${asked.line}</p>
        <div class="choice-options">${asked.options
          .map(
            (option, index) =>
              `<button class="choice-option" type="button" data-id="${option.id}"><i>${index + 1}</i>${option.label}</button>`
          )
          .join('')}</div>
      </div>`;
    for (const button of root.querySelectorAll('.choice-option')) {
      button.addEventListener('click', () => pick(button.dataset.id));
    }
  }

  window.addEventListener('keydown', (event) => {
    if (!asked || event.repeat) return;
    const digit = /^(?:Digit|Numpad)([1-9])$/.exec(event.code);
    if (!digit) return;
    const option = asked.options[Number(digit[1]) - 1];
    if (!option) return;
    event.preventDefault();
    pick(option.id);
  });

  return {
    root,
    get open() {
      return !root.hidden;
    },
    /** What is being asked right now, for a check. */
    get asking() {
      return asked ? { title: asked.title, line: asked.line, options: asked.options.map((o) => ({ ...o })) } : null;
    },
    show(next) {
      asked = next;
      render();
      root.hidden = false;
    },
    pick,
    close() {
      root.hidden = true;
      asked = null;
    },
  };
}
